const messages = {
  seasons: {
    all: "Sve sezone",
    summer: "Ljeto",
    winter: "Zima",
    general: "Opšte",
  },
  offer:
    "Redovno proširujemo naše <br />ponude za vas! <br /><br />Obavijestit ćemo vas o novim kursevima za obuku u vašoj primljenoj pošti.",
  summary: {
    congratulations: "ČESTITAMO - ZAVRŠILI STE VAŠU EKSPERTIZU O",
    participation:
      "Uspješno ste završili online obuku za Transporter gume za sve sezone.",
    certificate:
      "Vaš certifikat će vam biti poslat email-om ili možete direktno preuzeti kao PDF ovdje:",
    send: "Preuzmi certifikat",
  },
  online: {
    title: "Naši online treningi",
    desc: "Osigurajte ekspertsko znanje i, nakon uspješnog završetka odgovarajućih testova za obuku, vaš<br> lični certifikat o učešću kao i 40 dodatnih bodova za premium klub po prvi put",
    content:
      "Otkrijte naše trenutne online treninge sada i učestvujte odmah na platformi ovdje:",
    categories: {
      title: "Online trening",
      description:
        "Ostanite ispred sa znanjem: Osigurajte ekskluzivnu ekspertizu za vas i vaš tim sa našim ponudama obuke. Bilo da su to naše online sesije obuke, kojima možete direktno učestvovati na platformi, naši kursevi i praktični seminari u Bridgestone centru za obuku, ili čak vanjski trening čiji troškovi mogu biti smanjeni vašim premium bodovima.",
      general: {
        title: "Opšte",
        subtitle: "Online trening: Opšte",
        description:
          "Otkrijte najnovije tehnologije, važne razvoje u industriji guma, savjete za vašu prodaju, i još mnogo toga.",
        subdesription:
          "Osigurajte ekspertsko znanje i, nakon uspješnog završetka odgovarajućih testova obuke, vaš lični certifikat o učešću kao i jednokratni bonus od 40 dodatnih bodova za premium klub.",
      },
      product: {
        title: "Proizvodi",
        subtitle: "Online trening: Proizvodi",
        description:
          "Produbite vašu Bridgestone i Firestone ekspertizu o proizvodima za uspješnu prodaju sa našim kompaktnim video obukama.",
        subdesription:
          "Osigurajte ekspertsko znanje i, nakon uspješnog završetka odgovarajućih testova obuke, vaš lični certifikat o učešću kao i jednokratni bonus od 40 dodatnih bodova za premium klub.",
      },
    },
  },
  lectures: {
    title: "Bridgestone treningi",
    desc: "Proširite vašu ekspertizu i rezervišite naše treninge i intenzivne treninge za vas i vaš tim. Imate opciju da učestvujete u treningima u Bridgestone centru kompetencija i obuke u Dietzenbachu (blizu Frankfurta na Majni) ili, za odabrane treninge, da se oni provode u vašoj kompaniji. Možete koristiti vaše bonus bodove za treninge i tako pokriti troškove u cijelosti ili djelomično vašim bodovima.",
    content: "Otkrijte naše trenutne treninge sada i zatražite rezervaciju:",
  },
  singleLecture: {
    registerForm: {
      title: "Sadržaj treninga",
      inquiry: "Upit",
      interested: "Zainteresovan sam za trening",
      participantsNr: "Broj učesnika",
      pointsFromBalance: "Želim koristiti bodove iz mog stanja bodova.",
      reduction: "Ovo odgovara smanjenju troškova od {points} eura.",
      request: "Pošalji upit",
    },
    success: {
      thanks: "Hvala vam",
      title: "Vaš upit je poslat timu za obuku.",
      feedbackTime:
        "Primit ćete odgovor u roku od 14 dana da razjasnimo sve detalje.",
      points:
        "Korišteni bonus bodovi u iznosu od<br /><strong>{points}</strong> bodova su oduzeti sa vašeg<br />računa bodova.",
      refund:
        "Ako trening ne bude održan, bodovi će naravno biti vraćeni na vaš račun.",
      queries: "Za pitanja, molimo kontaktirajte:",
    },
    index: {
      costs: "Troškovi i informacije o učešću",
      duration: "Trajanje: {duration}",
      cost: "Troškovi {cost}: {price} eura",
      participantsNr: "Učesnici: min. {min} - max. {max} ljudi",
    },
  },
  index: {
    title: "Trening i obrazovanje",
    desc: "Prednost kroz znanje: Osigurajte ekskluzivno stručno znanje za vas i vaš tim sa našim ponudama obuke. Bilo sa našim online treningom, kojem možete direktno učestvovati na platformi, sa našim treningom i praktičnim seminarima u Bridgestone centru za obuku ili sa vanjskim treningom, čiji troškovi možete smanjiti vašim nagradnim bodovima.",
    online: {
      title: "Online treningi",
      desc: "Učestvujte direktno na platformi i osigurajte {points} bodova za premium klub.",
    },
    lectures: {
      title: "Treningi",
      desc: "Visokokvalitetni treningi u našem centru za obuku ili na vašoj lokaciji.",
    },
    external: {
      title: "Vanjski treningi",
      desc: "Koristite bonus bodove za ponude od trećih strana i smanjite troškove.",
    },
  },
  single: {
    done: "Trening je zavrsen.",
    doneDownloadCertificate: "Trening je zavrsen. Preuzmi certifikat.",
  },
  certificate: {
    header: "CERTIFIKAT",
    atCourse: "je uspješno učestvovao/la u",
    takePart: "kursu.",
    contains: "KOMPONENTE KURSA",
    country: "Velika Britanija",
  },
};

export default {
  messages,
};
